import React, { useEffect, useState } from "react";
import LandingLayout from "../LandingLayout";
import QuizForm from "../QuizForm";
import { PLATFORM_BRAND } from "../config";
import { QuizV2Entry, QuizV2Proof, QuizV2Top } from "./QuizV2Parts";
import "./quizV2.css";

// Quiz V2: the accident-type tap on the first page opens a distraction-free, app-like question flow.
export default function QuizV2Page({ page, vertical, layoutProps, quizProps, brandStyle, trackingEl, phone }) {
  const [flow, setFlow] = useState(false);
  const cfg = quizProps.quizConfig || {};
  const flowPhone = !layoutProps.hidePhone && phone && cfg.v2_phone === "all_screens" ? phone : null;
  const heroImg = page.hero_image_url && !page.no_hero_image ? { "--qv2-hero": `url(${page.hero_image_url})` } : undefined;
  useEffect(() => { window.scrollTo({ top: 0 }); }, [flow]);
  return (
    <LandingLayout {...layoutProps} minimal={flow}>
      {trackingEl}
      <div className={`qv2 ${flow ? "qv2-is-flow" : "qv2-is-entry"}`} style={brandStyle}
           data-qv2-mode={flow ? "flow" : "entry"} data-testid="quiz-v2-page">
        <div className="qv2-top" style={flow ? undefined : heroImg}>
          {flow
            ? <QuizV2Top brand={layoutProps.brand || PLATFORM_BRAND} logo={layoutProps.brandLogo} phone={flowPhone}
                         buyerCode={layoutProps.buyerCode} />
            : <QuizV2Entry vertical={vertical} page={page} />}
          <div className="qv2-card-wrap">
            <QuizForm {...quizProps} onFlowChange={setFlow} />
          </div>
        </div>
        {!flow && <QuizV2Proof page={page} buyerCode={layoutProps.buyerCode} />}
      </div>
    </LandingLayout>
  );
}
